import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import { FundAccountService } from '@pg-app/client/client-dashboard/components/fund-account/service/fund-account.service';
// tslint:disable-next-line:max-line-length
import { SendPaymentInstructionComponent } from '@pg-app/client/send-payment-instruction/containers/send-payment/send-payment-instruction.component';
import { format } from 'date-fns';
import { ToastrService } from 'ngx-toastr';
import { UtilityService } from '@nttp/common-service/utility-service';
import { AppInsightsService } from '@markpieszak/ng-application-insights';
import { DateCommonService } from '@nttp/common-service/date-common';
import { SendPaymentInstructionModelService } from '@pg-app/client/send-payment-instruction/services/send-payment-instruction.model.service';
import { FundOptionsComponent } from '@pg-app/client/client-dashboard/components/fund-account/fund-options/fund-options.component';
import { IOTBanksComponent } from '@pg-app/client/client-dashboard/components/fund-account/IOT/banks/iot-banks.component';
import { RecipientService } from '@pg-app/client/manage-recipient/services/recipient.service';
import { Subscription } from 'rxjs';
import { timer } from 'rxjs';
import { UUID } from 'angular2-uuid';
import { DownloadFileTypeEnum } from '@nttp/enum/download-file-type-enum';
import { environment } from '@pg-env/environment';

@Component({
  selector: 'np-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class FundAccountModalComponent implements OnInit {
  public fasterPaymentData = {
    bankName: '',
    accountNumber: '',
    bankCode: '',
    sortCode: '',
    iban: '',
    swiftCode: '',
    accountName: ''
  };
  public fundAccountPart3 = true;
  public fundAccountPart2 = true;
  public disableRadioButton = false;
  public DEFAULT_DISABLE_VALUE = 1000;
  public tradeReference = '';
  public switchingToExternalIOT = false;

  public modalModel = {
    buyAmount: 0,
    payAmount: 0,
    exchangeRate: 0,
    exchangeFee: 0,
    valueDate: '',
    currencyCodeBuy: {
      code: '',
      id: ''
    },
    currencyCodePay: {
      code: '',
      id: ''
    },
    tradeReference: '',
    tradeReferenceCleaned: '',
    deposited: 0,
    showDeposited: false,
    quoteId: null
  };

  timer = 16;
  countDown: Subscription;
  insertTrade = false;
  // show hide screen
  public transactionConfirmation = false;
  public fasterPayment = true;
  tradeConfirmation = false;
  currencies = [];
  isForwardTrade = false;
  depositAmount: any;
  balanceAmount: any;
  balanceDueDate: Date;
  depositDueDate: Date;
  buyCurrencyMandate = null;
  tradeId = '';
  isPrivalgoMarkets = environment.isPrivalgoMarkets;
  domain = environment.domain;
  brandName = environment.brandName;

  constructor(
    private fundAccountService: FundAccountService,
    private dialog: MatDialog,
    private toasterService: ToastrService,
    private utilService: UtilityService,
    private dateService: DateCommonService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appInsightsService: AppInsightsService,
    private sendPaymentInstructionModel: SendPaymentInstructionModelService,
    private recipientService: RecipientService
  ) {}

  ngOnInit() {
    if (this.data?.iotInfo?.redirectedFromIOT) {
      this.getFasterPaymentData();

      // Must set these 2 variables to hide the other parts of the components
      this.tradeConfirmation = true;
      this.insertTrade = true;

      // Show the response dialog with IOT result
      this.showManualPayment();
    }

    this.getValue();
  }

  public getValue() {
    this.modalModel = {
      buyAmount: this.data.buyAmount.toString(),
      payAmount: this.data.payAmount.toString(),
      currencyCodeBuy: {
        code: this.data.currencyCodeBuy.code,
        id: this.data.currencyCodeBuy.id
      },
      currencyCodePay: {
        code: this.data.currencyCodePay.code,
        id: this.data.currencyCodePay.id
      },
      exchangeRate: this.data.exchangeRate,
      exchangeFee: this.data.exchangeFee,
      valueDate: format(this.data.valueDate, 'DD/MM/YYYY'),
      tradeReference: this.data.tradeReference,
      tradeReferenceCleaned: this.data.tradeReference.replace(/^0+/, ''), // Remove the leading zeros from the number string
      deposited: this.data.deposited,
      showDeposited: this.data.showDeposited,
      quoteId: this.data.quoteId
    };

    this.depositAmount =
      this.modalModel.deposited && this.modalModel.deposited !== 0
        ? (this.modalModel.deposited * this.modalModel.payAmount) / 100
        : null;
    this.balanceAmount = this.depositAmount
      ? this.modalModel.payAmount - (this.modalModel.deposited * this.modalModel.payAmount) / 100
      : null;
    this.disableRadioButton = this.modalModel.payAmount > this.DEFAULT_DISABLE_VALUE;
    this.balanceDueDate = this.data.isForwardTrade
      ? this.getDateWorkingDay(this.data.valueDate, -1)
      : this.data.valueDate;
    this.depositDueDate =
      this.data.isForwardTrade && this.data.deposited && this.data.deposited > 0
        ? this.getDateWorkingDay(new Date(), 2)
        : null;
    this.countdownTimer();
  }

  countdownTimer() {
    this.countDown = timer(0, 1000).subscribe(x => {
      this.timer = this.timer - 1;
      if (this.timer <= 0 && !this.insertTrade) {
        this.countDown.unsubscribe();
        this.dialog.closeAll();
      }
    });
  }

  onDestroy() {
    this.countDown.unsubscribe();
  }

  continue() {
    this.countDown.unsubscribe();
    const params = {
      dupKey: UUID.UUID(),
      valueDateString: format(this.data.valueDate, 'YYYYMMDD'),
      inputDateString: format(new Date(), 'YYYYMMDD'),
      soldOfferInfo: {
        currencyCode: this.data.currencyCodePay.code,
        currencyId: this.data.currencyCodePay.id,
        quantity: parseFloat(this.data.payAmount)
      },
      boughtOfferInfo: {
        currencyCode: this.data.currencyCodeBuy.code,
        currencyId: this.data.currencyCodeBuy.id,
        quantity: parseFloat(this.data.buyAmount)
      },
      exchangeRate: parseFloat(this.data.exchangeRate),
      isSellChanged: this.data.isSellChanged,
      depositCurrencyId: this.data.depositCurrencyId,
      quoteId: this.data.quoteId
    };
    this.fundAccountService.getTransaction(params).subscribe(
      data => {
        this.tradeId = data.tradeId;
        this.insertTrade = true;
        this.modalModel.tradeReference = data.tradeReference;
        this.modalModel.tradeReferenceCleaned = data.tradeReference.replace(/^0+/, ''); // Remove the leading zeros from the number string
        this.getFasterPaymentData();
        this.fundAccountPart2 = false;
        this.tradeConfirmation = true;
        sessionStorage.setItem('clickBuyNow', 'true');
      },
      err => {
        this.insertTrade = false;
      }
    );
  }

  cancelBookTrade() {
    this.countDown.unsubscribe();
    this.dialog.closeAll();
    sessionStorage.setItem('clickBuyNow', 'false');
  }

  public nextPart2() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.width = '20vw';
    dialogConfig.hasBackdrop = true;

    // Find out if there is a mandate set up against the buying currency
    this.buyCurrencyMandate = null;
    this.recipientService.getUniqueRecipientPerCurrency(this.data.currencyCodeBuy.code).subscribe(res => {
      if (res && res.receipient) {
        this.buyCurrencyMandate = res.receipient;
      }
    });

    const param = {
      Currency: this.data.currencyCodePay.code,
      Amount: this.data.payAmount
    };

    this.fundAccountService.getIsIOTPermitted(param).subscribe(
      x => {
        if (x === '1') {
          // IOT permitted, give user options as how s/he wants to proceed
          this.dialog
            .open(FundOptionsComponent, dialogConfig)
            .afterClosed()
            .subscribe(y => {
              if (y === '2') {
                // Starting integrated online transfer
                this.startIOT();
              } else if (y === '1') {
                this.showManualPayment();
              } else {
                // Go back to the previous screen, which is still in the background... so no need to do anything
              }
            });
        } else {
          // IOT NOT permitted, so simply follow the existing manual payment process
          this.showManualPayment();
        }
      },
      err => {
        if (err.error && err.error.messages && err.error.messages.length > 0) {
          this.toasterService.error(err.error.messages[0] + '. You will be diverted to manual payment instead.');
        } else {
          this.toasterService.error(
            'Something has gone wrong with unknown reasons. You will be diverted to manual payment instead.'
          );
        }
        this.showManualPayment();
      }
    );
  }

  private startIOT() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.width = '550px';
    dialogConfig.hasBackdrop = true;
    dialogConfig.data = {
      tradeReferenceCleaned : this.modalModel.tradeReferenceCleaned,
      payingCurrencyCode: this.modalModel.currencyCodePay.code
    };

    this.dialog.open(IOTBanksComponent, dialogConfig)
      .afterClosed().subscribe(
        bankSelected => {
          if (bankSelected !== undefined) {
            const iotPaymentRequest = {
              BankId: bankSelected.bankId,
              BankName: bankSelected.bankName,
              BankCountryCode: bankSelected.bankCountryCode,
              PaymentRef: this.modalModel.tradeReferenceCleaned,
              PaymentDescription: 'IOT Payment for ' + this.modalModel.tradeReferenceCleaned,
              Amount: this.modalModel.payAmount,
              Currency: this.modalModel.currencyCodePay.code,
              SuccessRedirectUri: window.origin + '/client/dashboard',
              ErrorRedirectUri: window.origin + '/client/dashboard'
            };

            this.fundAccountService.initiateIOTPayment(iotPaymentRequest).subscribe(
              res => {
                this.switchingToExternalIOT = true;
                window.location.href = res.redirectUrl;     // This will redirect to external bank's portal
              },
              err => {
                // Error encountered. Not need to show any popup message. 
                // Instead, fail gracefully and show the alternative manual payment method.
                
                this.data.iotInfo.redirectedFromIOT = true; 
                this.data.iotInfo.processedOkIOT = false;

                this.buyCurrencyMandate = false;

                this.showManualPayment();
              }
            );
          }
        }
      );
  }

  private showManualPayment() {
    this.fundAccountPart2 = true;
    this.fundAccountPart3 = false;
  }

  private showTransactionDetails() {
    this.fundAccountPart2 = false;
    this.fundAccountPart3 = true;
  }

  public finish() {
    this.dialog.closeAll();
    window.location.reload();
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  public payRecipient() {
    this.dialog.closeAll();
    this.showDialog();
  }

  showDialog() {
    this.sendPaymentInstructionModel.clearData();
    this.sendPaymentInstructionModel.clearDataAfterFunAccount();

    this.sendPaymentInstructionModel.recipientMandate = this.buyCurrencyMandate;
    this.sendPaymentInstructionModel.tradeId = this.tradeId;
    this.sendPaymentInstructionModel.currency.code = this.data.currencyCodeBuy.code;
    this.sendPaymentInstructionModel.currency.id = this.data.currencyCodeBuy.id;
    this.sendPaymentInstructionModel.amount = this.data.buyAmount;
    this.sendPaymentInstructionModel.tradeValueDate = this.data.valueDate;
    this.sendPaymentInstructionModel.paymentDate = this.data.valueDate;
    if (this.buyCurrencyMandate) {
      this.sendPaymentInstructionModel.step = this.sendPaymentInstructionModel.sendPaymentStep.paymentMandate;
    } else {
      this.sendPaymentInstructionModel.step = this.sendPaymentInstructionModel.sendPaymentStep.paymentInfo;
    }

    this.dialog.open(SendPaymentInstructionComponent, {
      disableClose: true,
      panelClass: 'custom-dialog'
    });
  }

  public getFasterPaymentData() {
    this.fundAccountService.getFasterPayment(this.data.currencyCodePay.id).subscribe(data => {
      this.fasterPaymentData = data;
    });
  }

  public exportExcel() {
    const params = {
      leadId: null,
      tradeNumber: parseFloat(this.modalModel.tradeReference)
    };
    this.fundAccountService.downloadPDF(params).subscribe(res => {
      const fileName = `Trade_${this.modalModel.tradeReference}.pdf`;
      this.viewPDF(res, fileName);
    });
  }

  viewPDF(data: any, fileName: string) {
    this.utilService.downloadFile(data, fileName, DownloadFileTypeEnum.PDF);
  }

  getDateWorkingDay(date, addDay) {
    return addDay > 0
      ? this.dateService.getWorkingDayWithWeekendAndHoliday(date, addDay, this.data.holidays)
      : this.dateService.getWorkingDayWithWeekendAndHolidayPre(date, addDay, this.data.holidays);
  }

  goBack() {
    this.showTransactionDetails();
  }
}
